




































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import RefreshCircleIcon from 'mdi-vue/RefreshCircle';
import FilterIcon from 'mdi-vue/Filter';
import CloseIcon from 'mdi-vue/Close';
import { mapState } from 'vuex';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Toggle from '@/components/Toggle.vue';
import Button from '@/components/Button.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import { api2 } from '@/libs/api';
import SingleDatePickerNoTP from '@/components/SingleDatePickerNoTP.vue';
import UploadHistoryTable from './UploadHistoryTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    Toggle,
    Button,
    SearchIcon,
    RefreshCircleIcon,
    SearchField,
    SearchRow,
    UploadHistoryTable,
    FilterIcon,
    CloseIcon,
    SingleDatePickerNoTP,
  },
  computed: mapState(['user']),
})
export default class UploadHistory extends Vue {
  searchOpen = false;

  columns = [];

  searchParams: any = {};

  loadingRefreshBtn = false;

  $refs!: {
    report: UploadHistoryTable;
  }

  mounted() {
    this.getTransaction(0);
  }

  async getTransaction(pageParams: any) {
    if (this.columns.length === 0) {
      const templateCode = 'jobReconUpload';
      const { data } = await api2.post(`/recon/stg/conf/${templateCode}`, {});
      data.forms.forEach((element: any) => {
        this.searchParams[element.id] = '';
      });
      // console.log(JSON.stringify(this.searchParams));
      this.columns = data.forms;
      // this.$forceUpdate();
    }
    await this.$refs.report.getTransaction(this.columns, this.searchParams, pageParams);
  }

  parseParams() {
    this.getTransaction(0);
  }

  search() {
    this.getTransaction(0);
  }

  refresh() {
    this.loadingRefreshBtn = true;
    this.getTransaction(0);
    this.loadingRefreshBtn = false;
  }

  cancel() {
    this.columns.forEach((element: any) => {
      this.searchParams[element.id] = '';
      this.searchParams[element.column_db] = '';
    });
    this.toggleSearchOpen();
    this.getTransaction(0);
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
